<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{headingText}}</h4>
  <div *ngIf="!loading; else loader">

    <mat-form-field class="w-100">
      <buffered-input (keyup)="applyFilter($event.target.value)" placeholder="Filtro"></buffered-input>
    </mat-form-field>

    <resourceful-index #index [search]="search" [modelService]="tipoAltroSoggettoService"
      [deleteFunction]="deleteFunction" [columnDefinitions]="columnDefinitions" [editFunction]="editFunction"
      [selectionMode]="selectionMode" (selectedModel)="closeDialogWithSelectedModel($event)" [relations]="relations">
    </resourceful-index>

    <button mat-raised-button color="primary" class="mt-4" (click)="add()">
      Aggiungi un tipo di altro soggetto<mat-icon>add</mat-icon>
    </button>

  </div>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>